module.exports = __webpack_public_path__ + "static/img/paiduitongzhi2.3236e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/paiduitongzhi2.png
// module id = LXI3
// module chunks = 24